import { contentBasehost } from 'src/utils/environment';

export const CALLER_PAGE_NAME = 'categorypage';
export const CANCELLATION_POLICY_URL = `${contentBasehost}/cancellation-reschedule-policy`;
